import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'clp-course-progress-bar',
    templateUrl: './courseProgressBar.component.html',
    styleUrls: ['./courseProgressBar.component.scss'],
    imports: [
        TranslateModule,
    ]
})
export class CourseProgressBarComponent {
  @Input() currentStep: number = 0; // Progress value as a percentage (0-100)
  @Input() stepLabels: string[] = [
    'course.general-tab',
    'course.modules-tab',
    'course.lessons-tab',
    'course.review-tab'
  ];
  @Output() previousStep = new EventEmitter<string | null>();
  @Output() nextStep = new EventEmitter<string | null>();

  get totalSteps(): number {
    return this.stepLabels.length;
  }

  moveNext(): void {
    this.nextStep.emit();
  }

  movePrevious(): void {
      this.previousStep.emit();
  }
}
